import {
  SubscriptionInfoCard,
  SubscriptionPlanCards,
} from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/components';
import { SubscriptionInfo } from 'app/hooks/subscriptions/useSubscriptionInfo';
import React from 'react';
import { IEquipmentEntry } from 'types/IEquipmentEntry';

interface Props {
  equipment: IEquipmentEntry;
  subscriptionInfo: SubscriptionInfo;
}

export default function InitialPlanView({
  equipment,
  subscriptionInfo,
}: Props) {
  return (
    <>
      <SubscriptionInfoCard
        equipment={equipment}
        subscriptionInfo={subscriptionInfo}
        classname="premium-plan-view__subscription-info-card"
      />

      <SubscriptionPlanCards equipment={equipment} hideBasicCard />
    </>
  );
}
